import React from 'react';
import { Menu, Icon, Image } from 'semantic-ui-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import { connect } from 'react-redux';
import { isAdmin, isDemo } from '../users/selectors';
const SidebarComponent = props => {
  return (
    <div>
      <style>
        {`.ui.icon.menu .item {
    line-height: 40px;
    text-align: justify;
    font-weight: 600;
}

.ui.vertical.menu .item::before {
    height: 0px;
}

.ui.labeled.icon.menu .item > .icon:not(.dropdown) {
    float: left;
    margin-right: 12px !important;
}`}
      </style>
      <Menu
        vertical
        icon="labeled"
        fixed="left"
        style={{ backgroundColor: '#3b88f9' }}
        inverted>
        <Menu.Item>
          <Image src={logo} size="small" centered />
        </Menu.Item>
        <Menu.Item
          as={Link}
          name="home"
          to="/"
          active={props.activeTab === '/'}>
          <Icon name="home" />
          {props.t('sidebar:dashboard')}
        </Menu.Item>
        <Menu.Item
          as={Link}
          to="/cleaning"
          active={props.activeTab === '/cleaning'}>
          <Icon name="female" />
          {props.t('sidebar:cleaning')}
        </Menu.Item>
        <Menu.Item
          as={Link}
          name="Settings"
          to="/settings"
          active={props.activeTab === '/settings'}>
          <Icon name="cogs" />
          {props.t('sidebar:settings')}
        </Menu.Item>
        {props.isAdmin && !props.isDemo && (
          <Menu.Item
            as={Link}
            name="Wallet"
            to="/wallet"
            active={props.activeTab === '/wallet'}>
            <Icon name="dollar sign" />
            {props.t('wallet:walletHeaderText')}
          </Menu.Item>
        )}
        <Menu.Item
          as={Link}
          name="About"
          to="/about"
          active={props.activeTab === '/about'}>
          <Icon name="info" />
          {props.t('sidebar:about')}
        </Menu.Item>
      </Menu>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    isAdmin: isAdmin(state),
    isDemo: isDemo(state)
  };
};
export default translate('translations')(
  connect(mapStateToProps)(SidebarComponent)
);



// WEBPACK FOOTER //
// ./src/components/SidebarComponent.js